import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Incarico } from 'src/app/models/incarico';
import { IncaricoService } from 'src/app/services/incarico.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { findInRoute } from 'src/app/shared/utilities';
import { Polizza } from 'src/app/models/polizza';

@Component({
  selector: 'pregressi',
  templateUrl: './pregressi.component.html',
  styleUrls: ['./pregressi.component.scss']
})
export class PregressiComponent implements OnInit {

  headingText: string = 'Pregressi';


  relations: string[] = ['stato', 'polizza', 'polizza.compagnia', 'incaricato', 'tipo_danno', 'ramo', 'polizza.ramo'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Incarico',
        internalName: 'incarico',
        type: 'link',
        href: model => `/incarichi/${model.id}`,
        displayFunction: (model) => model?.humanIdentifier,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Stato',
        internalName: 'stato',
        displayFunction: model => model.stato?.nome,
        sortDisabled: true,
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',
        displayFunction: model => model.polizza?.compagnia?.nome,
        sortDisabled: true,
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Sinistro',
        internalName: 'sinistro',
        displayFunction: (model: Incarico) => model.numero_sinistro,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Ramo',
        internalName: 'ramo',
        displayFunction: (model: Incarico) => model?.ramo?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Tipo danno',
        internalName: 'tipo_danno',
        displayFunction: (model: Incarico) => model.tipo_danno?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Incaricato',
        internalName: 'incaricato',
        displayFunction: (model: Incarico) => model.incaricato?.humanIdentifier,
        sortDisabled: true,
      }
    ),
  ];
  constructor(public incaricoService: IncaricoService,
    private toast: ToastrService,
    private route: ActivatedRoute,) {

  }

  @Input() polizza: Polizza;

  async ngOnInit() {

    const idIncarico = findInRoute('idIncarico', this.route)
    if (!idIncarico && !this.polizza)
      throw "Impossibile trovare i pregressi: ID incarico mancante e polizza non fornita.";
    if (idIncarico) {
      this.search = { pregresso: { incarico: idIncarico } };
    }
    else
      this.search = { pregresso: { polizza: this.polizza.id } }

  }

}
